import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import {
  GetSupplierBranchUserResponse,
  Permissions,
  SupplierBranchUserEditRequest,
  SupplierBranchUserRequest,
} from "../../models/supplierUserBarnch.model";
import { object, string } from "yup";
import DatePickerComponents from "../datePicker/DatePickerComponents";
import SwitchCmp from "../switch/SwitchCmp";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import { Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: {
    xs: 350,
    sm: 400,
    md: 600,
  },
  maxWidth: {
    xs: 350,
    sm: 400,
    md: 600,
  },
  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  // paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const supplierBranchUserValidation = object().shape({
  firstName: string()
    .ensure()
    .required("لطفا نام را وارد نمایید.")
    .matches(/^(?!\s+$).*/, "لطفا نام را صحیح وارد نمایید")
    .max(250, "نام نباید بیشتر از ۲۵۰ باشد"),
  lastName: string()
    .ensure()
    .matches(/^(?!\s+$).*/, "لطفا نام خانوادگی را صحیح وارد نمایید")
    .required("لطفا نام خانوادگی را وارد نمایید.")
    .max(250, "نام خانوادگی نباید بیشتر از ۲۵۰ باشد"),

  mobileNumber: string()
    .ensure()
    .required("لطفا شماره موبایل را وارد نمایید.")
    .matches(
      /^(\+98|0098|98|0)?9\d{9}$/,
      "لطفا شماره موبایل را صحیح وارد نمایید"
    ),
  nationalCode: string()
    .ensure()
    .required("لطفا کدملی را وارد نمایید.")
    .min(10, "کدملی نباید کمتر از 10رقم باشد"),
});

interface Props {
  openSupplierBranchUserModal: boolean;
  setOpenSupplierBranchUserModal: (open: boolean) => void;
  handleAdd: Function;
  handleEdit: Function;
  supplierBranchRecord: GetSupplierBranchUserResponse | undefined;
  setSupplierBranchRecord: (
    usert: GetSupplierBranchUserResponse | undefined
  ) => void;
  allPermissions: Permissions[];
}
const ModalSupplierBranchUser = ({
  openSupplierBranchUserModal,
  setOpenSupplierBranchUserModal,
  handleAdd,
  handleEdit,
  supplierBranchRecord,
  setSupplierBranchRecord,
  allPermissions,
}: Props) => {
  const [birthDate, setBirthDate] = useState<any>();
  const [status, setstatus] = useState<boolean>(true);

  const [initialValues, setInitialValues] = useState<
    Omit<SupplierBranchUserRequest, "birthDate" | "isActive">
  >({
    mobileNumber: "",
    nationalCode: "",
    firstName: "",
    lastName: "",
    permissions: [],
  });

  useEffect(() => {
    if (openSupplierBranchUserModal) {
      if (supplierBranchRecord) {
        // حالت ویرایش
        setInitialValues({
          mobileNumber: supplierBranchRecord.mobileNumber,
          nationalCode: supplierBranchRecord.nationalCode,
          firstName: supplierBranchRecord.firstName,
          lastName: supplierBranchRecord.lastName,
          permissions: supplierBranchRecord.permissions,
        });
      } else if (allPermissions.length > 0) {
        // حالت افزودن
        setInitialValues({
          mobileNumber: "",
          nationalCode: "",
          firstName: "",
          lastName: "",
          permissions: allPermissions.map((p) => ({ ...p, isActive: false })),
        });
      }
    }
  }, [openSupplierBranchUserModal, supplierBranchRecord, allPermissions]);

  const handleFormSubmit = (
    values: Omit<SupplierBranchUserRequest, "birthDate" | "isActive">
  ) => {
    // values = {
    //   ...values,
    //   isActive: status,
    //   birthDate: new Date(convertToLocalDateTime(Number(birthDate!))),
    // };
    const valueToService = {
      ...values,
      isActive: status,
      birthDate:
        birthDate === supplierBranchRecord?.birthDate_Persian
          ? supplierBranchRecord?.birthDate
          : new Date(convertToLocalDateTime(Number(birthDate!))),
      permissions: values.permissions.filter((p) => p.isActive === true),
    };
    if (supplierBranchRecord) {
      const editData: SupplierBranchUserEditRequest = {
        ...valueToService,
        // birthDate: supplierBranchRecord.birthDate,
        supplierUserId: supplierBranchRecord.id,
        permissions: initialValues.permissions.filter(
          (p) => p.isActive === true
        ),
      };
      handleEdit(editData);
    } else {
      handleAdd(valueToService);
    }
  };

  useEffect(() => {
    if (supplierBranchRecord) {
      supplierBranchRecord?.isActiveTitle === "فعال"
        ? setstatus(true)
        : setstatus(false);
      setBirthDate(supplierBranchRecord?.birthDate_Persian);
    }
  }, [supplierBranchRecord]);

  const handleCheckBox = (id: number, isActive: boolean) => {
    let updatedPermissions = initialValues.permissions?.map((item) => {
      if (item.id === id) {
        return { ...item, isActive: !isActive };
      }
      return item;
    });
    initialValues.permissions = updatedPermissions;
  };
  return (
    <>
      <Modal
        open={openSupplierBranchUserModal}
        onClose={() => {
          setOpenSupplierBranchUserModal(false);
          setBirthDate(undefined);
          setstatus(true);
          setSupplierBranchRecord(undefined);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                color={"#1D4A87"}
                fontSize={"18px"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                // fontSize={"44px"}
              >
                افزودن کاربر
              </Typography>
            </Grid>
            <Formik
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              validationSchema={supplierBranchUserValidation}
              enableReinitialize
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                setFieldValue,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      flexDirection={"row"}
                      justifyContent={"start"}
                      spacing={2}
                    >
                      <Grid item xs={6}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام"}
                          label={"نام"}
                          required={true}
                          name="firstName"
                          id="firstName"
                          helperText={touched.firstName ? errors.firstName : ""}
                          error={touched.firstName && Boolean(errors.firstName)}
                          onChange={handleChange}
                          value={values.firstName}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام خانوادگی"}
                          label={"نام خانوادگی"}
                          required={true}
                          name="lastName"
                          id="lastName"
                          helperText={touched.lastName ? errors.lastName : ""}
                          error={touched.lastName && Boolean(errors.lastName)}
                          onChange={handleChange}
                          value={values.lastName}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <MaterialTextFieldComponent
                          placeHolder={"کد ملی"}
                          label={"کد ملی"}
                          required={true}
                          name={"nationalCode"}
                          id={"nationalCode"}
                          inputProps={{ maxLength: 10 }}
                          value={values.nationalCode}
                          onChange={handleChange}
                          helperText={
                            touched.nationalCode ? errors.nationalCode : ""
                          }
                          error={
                            touched.nationalCode && Boolean(errors.nationalCode)
                          }
                          onBlur={handleBlur}
                          onKeyDown={(event) => {
                            if (
                              event.code === "Space" ||
                              (!/^[0-9]$/.test(event.key) &&
                                event.code !== "Backspace")
                            )
                              event.preventDefault();
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <MaterialTextFieldComponent
                          placeHolder={"شماره موبایل"}
                          label={"شماره موبایل"}
                          required={true}
                          name={"mobileNumber"}
                          id={"mobileNumber"}
                          inputProps={{ maxLength: 11 }}
                          value={values.mobileNumber}
                          onChange={handleChange}
                          helperText={
                            touched.mobileNumber ? errors.mobileNumber : ""
                          }
                          error={
                            touched.mobileNumber && Boolean(errors.mobileNumber)
                          }
                          onBlur={handleBlur}
                          onKeyDown={(event) => {
                            if (
                              event.code === "Space" ||
                              (!/^[0-9]$/.test(event.key) &&
                                event.code !== "Backspace")
                            )
                              event.preventDefault();
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth className="shadowDatepicker">
                          <DatePickerComponents
                            value={birthDate!}
                            label={"*تاریخ تولد"}
                            //  helperText={IsshowInputErrors ? RequiredField : ""}
                            // error={IsshowInputErrors}
                            onChange={(newValue: any) => {
                              setBirthDate(newValue);
                            }}
                            range={false}
                          />
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        maxWidth={209}
                        className="certificate-switch"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <SwitchCmp
                          Label={"وضعیت"}
                          checked={status === true}
                          onChange={(checked: boolean) => {
                            setstatus(checked);
                          }}
                          onlabel={"فعال"}
                          offlabel={"غیرفعال"}
                          colSize="col-lg-6 col-6"
                        />
                      </Grid>
                      <Grid
                        container
                        item
                        spacing={1}
                        sx={{
                          border: "1px solid #ccc",
                          marginTop: "30px",
                          marginLeft: "16px",
                          borderRadius: "5px",
                          pt: 0.5,
                          px: 2,
                          pb: 2,
                        }}
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle1"
                            style={{
                              marginTop: "-2.8rem",
                              backgroundColor: "#fff",
                              marginRight: "-8px",
                              maxWidth: "fit-content",
                              paddingLeft: "7px",
                              paddingRight: "7px",
                              color: "rgba(0,0,0,0.6)",
                            }}
                          >
                            دسترسی ها
                          </Typography>
                        </Grid>
                        {values.permissions?.map((item: any, index: number) => {
                          return (
                            <Grid
                              item
                              xs={6}
                              sx={{
                                minHeight: "35px",
                                height: "35px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <FormControlLabel
                                label={
                                  <span style={{ fontSize: "13px" }}>
                                    {item.title}
                                  </span>
                                }
                                control={
                                  <Checkbox
                                    checked={item.isActive}
                                    onChange={() => {
                                      const updated = values.permissions.map(
                                        (perm, i) =>
                                          i === index
                                            ? {
                                                ...perm,
                                                isActive: !perm.isActive,
                                              }
                                            : perm
                                      );
                                      setFieldValue("permissions", updated);
                                      initialValues.permissions = updated;
                                    }}
                                    disabled={false}
                                    value={item.id}
                                    sx={{
                                      "&.Mui-disabled": { color: "#1976d2" },
                                      "& .MuiSvgIcon-root": { fontSize: 22 },
                                      padding: "4px",
                                    }}
                                  />
                                }
                                sx={{ margin: 0, minHeight: "32px" }}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"center"}
                          spacing={2}
                        >
                          <Grid item xs={12} sm={12} md={12} lg={6}>
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.firstName ||
                                !values.lastName ||
                                values.nationalCode.length !== 10 ||
                                values.mobileNumber.length !== 11 ||
                                !birthDate
                              }
                              className={
                                !values.firstName ||
                                !values.lastName ||
                                values.nationalCode.length !== 10 ||
                                values.mobileNumber.length !== 11 ||
                                !birthDate
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={6}>
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenSupplierBranchUserModal(false);
                                setBirthDate(undefined);
                                setstatus(true);
                                setSupplierBranchRecord(undefined);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ModalSupplierBranchUser;
